/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import './ww-set.scss';
import { StaticImage } from 'gatsby-plugin-image';
import { Accordion } from 'react-bootstrap';

interface IProps {
  set: string;
}

export const WWSetProfile: React.FC<IProps> = ({ set }) => {
  return (
    <>
      <Accordion className="ww-set-accordion">
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <div className={`ww-set-image ${set}`}>
              {set === 'Freezing Frost' && (
                <StaticImage
                  src="../../../../images/ww/icons/set_1.webp"
                  alt="Set"
                />
              )}
              {set === 'Molten Rift' && (
                <StaticImage
                  src="../../../../images/ww/icons/set_2.webp"
                  alt="Set"
                />
              )}
              {set === 'Void Thunder' && (
                <StaticImage
                  src="../../../../images/ww/icons/set_3.webp"
                  alt="Set"
                />
              )}
              {set === 'Sierra Gale' && (
                <StaticImage
                  src="../../../../images/ww/icons/set_4.webp"
                  alt="Set"
                />
              )}
              {set === 'Celestial Light' && (
                <StaticImage
                  src="../../../../images/ww/icons/set_5.webp"
                  alt="Set"
                />
              )}
              {(set === 'Havoc Eclipse' || set === 'Sun-sinking Eclipse') && (
                <StaticImage
                  src="../../../../images/ww/icons/set_6.webp"
                  alt="Set"
                />
              )}
              {set === 'Rejuvenating Glow' && (
                <StaticImage
                  src="../../../../images/ww/icons/set_7.webp"
                  alt="Set"
                />
              )}
              {set === 'Moonlit Clouds' && (
                <StaticImage
                  src="../../../../images/ww/icons/set_8.webp"
                  alt="Set"
                />
              )}
              {(set === 'Endless Resonance' || set === 'Lingering Tunes') && (
                <StaticImage
                  src="../../../../images/ww/icons/set_9.webp"
                  alt="Set"
                />
              )}
              {set === 'Frosty Resolve' && (
                <StaticImage
                  src="../../../../images/ww/icons/set_10.webp"
                  alt="Set"
                />
              )}
              {set === 'Eternal Radiance' && (
                <StaticImage
                  src="../../../../images/ww/icons/set_11.webp"
                  alt="Set"
                />
              )}
              {set === 'Midnight Veil' && (
                <StaticImage
                  src="../../../../images/ww/icons/set_12.webp"
                  alt="Set"
                />
              )}
              {set === 'Empyrean Anthem' && (
                <StaticImage
                  src="../../../../images/ww/icons/set_13.webp"
                  alt="Set"
                />
              )}
              {set === 'Tidebreaking Courage' && (
                <StaticImage
                  src="../../../../images/ww/icons/set_14.webp"
                  alt="Set"
                />
              )}
              {set === 'Gusts of Welkin' && (
                <StaticImage
                  src="../../../../images/ww/icons/set_15.webp"
                  alt="Set"
                />
              )}
            </div>
            {set === 'Endless Resonance' && 'Lingering Tunes'}
            {set === 'Sun-sinking Eclipse' && 'Havoc Eclipse'}
            {set != 'Sun-sinking Eclipse' && set != 'Endless Resonance' && set}
          </Accordion.Header>
          <Accordion.Body>
            <div className={`ww-set-description`}>
              {set === 'Freezing Frost' && (
                <>
                  <p>
                    <span>2 Set:</span>{' '}
                    <strong className="Glacio">Glacio</strong> DMG increases by{' '}
                    <strong>10%</strong>.
                  </p>
                  <p>
                    <span>5 Set:</span> Upon using Basic Attack or Heavy Attack,{' '}
                    <strong className="Glacio">Glacio DMG</strong> increases by{' '}
                    <strong>10%</strong>, stacking up to three times, lasting
                    for
                    <strong>15s</strong>.
                  </p>
                </>
              )}
              {set === 'Molten Rift' && (
                <>
                  <p>
                    <span>2 Set:</span>{' '}
                    <strong className="Fusion">Fusion</strong> DMG% increases by{' '}
                    <strong>10%</strong>.
                  </p>
                  <p>
                    <span>5 Set:</span> Upon using Resonance Skill,{' '}
                    <strong className="Fusion">Fusion DMG</strong> increases by{' '}
                    <strong>30%</strong> for <strong>15s</strong>.
                  </p>
                </>
              )}
              {set === 'Void Thunder' && (
                <>
                  <p>
                    <span>2 Set:</span>{' '}
                    <strong className="Electro">Electro</strong> DMG increases
                    by <strong>10%</strong>.
                  </p>
                  <p>
                    <span>5 Set:</span> Upon using Heavy Attack or Resonance
                    Skill, <strong className="Electro">Electro DMG</strong>{' '}
                    increases by <strong>15%</strong>, stacking up to{' '}
                    <strong>2</strong> times, each stack lasting for{' '}
                    <strong>15s</strong>.
                  </p>
                </>
              )}
              {set === 'Sierra Gale' && (
                <>
                  <p>
                    <span>2 Set:</span> <strong className="Aero">Aero</strong>{' '}
                    DMG increase by <strong>10%</strong>.
                  </p>
                  <p>
                    <span>5 Set:</span> Upon using Intro Skill,{' '}
                    <strong className="Aero">Aero DMG</strong> increases by{' '}
                    <strong>30%</strong> for <strong>15s</strong>.
                  </p>
                </>
              )}
              {set === 'Celestial Light' && (
                <>
                  <p>
                    <span>2 Set:</span>{' '}
                    <strong className="Spectro">Spectro</strong> DMG increases
                    by <strong>10%</strong>.
                  </p>
                  <p>
                    <span>5 Set:</span> Upon using Intro Skill,{' '}
                    <strong className="Spectro">Spectro DMG</strong> increases
                    by <strong>30%</strong> for <strong>15s</strong>.
                  </p>
                </>
              )}
              {(set === 'Havoc Eclipse' || set === 'Sun-sinking Eclipse') && (
                <>
                  <p>
                    <span>2 Set:</span> <strong className="Havoc">Havoc</strong>{' '}
                    DMG increases by <strong>10%</strong>.
                  </p>

                  <p>
                    <span>5 Set:</span> Upon using Basic Attack or Heavy Attack,{' '}
                    <strong className="Havoc">Havoc DMG</strong> increases by{' '}
                    <strong>7.5%</strong>, stacking up to four times for{' '}
                    <strong>15s</strong>.
                  </p>
                </>
              )}
              {set === 'Rejuvenating Glow' && (
                <>
                  <p>
                    <span>2 Set:</span> Healing increases by{' '}
                    <strong>10%</strong>.
                  </p>
                  <p>
                    <span>5 Set:</span> Upon healing allies, increase ATK of the
                    entire team by <strong>15%</strong>, lasting{' '}
                    <strong>30s</strong>.
                  </p>
                </>
              )}
              {set === 'Moonlit Clouds' && (
                <>
                  <p>
                    <span>2 Set:</span> Energy Regen increases by{' '}
                    <strong>10%</strong>.
                  </p>
                  <p>
                    <span>5 Set:</span> Upon using Outro Skill, ATK of the next
                    Resonator increases by <strong>22.5%</strong> for{' '}
                    <strong>15s</strong>.
                  </p>
                </>
              )}
              {(set === 'Endless Resonance' || set === 'Lingering Tunes') && (
                <>
                  <p>
                    <span>2 Set:</span> ATK increases by <strong>10%</strong>.
                  </p>
                  <p>
                    <span>5 Set:</span> While on the field, ATK increases by{' '}
                    <strong>5%</strong> every <strong>1.5s</strong>, stacking up
                    to <strong>4</strong> times. Outro Skill DMG increases by{' '}
                    <strong>60%</strong>.
                  </p>
                </>
              )}
              {set === 'Frosty Resolve' && (
                <>
                  <p>
                    <span>2 Set:</span> Resonance Skill DMG +
                    <strong>12%</strong>.
                  </p>
                  <p>
                    <span>5 Set:</span> Casting Resonance Skill grants{' '}
                    <strong>22.5%</strong>{' '}
                    <strong className="Glacio">Glacio DMG</strong> Bonus for{' '}
                    <strong>15s</strong> and casting Resonance Liberation
                    increases Resonance Skill DMG by <strong>18%</strong>,
                    lasting for <strong>5s</strong>. This effect stacks up to{' '}
                    <strong>2</strong> times.
                  </p>
                </>
              )}
              {set === 'Eternal Radiance' && (
                <>
                  <p>
                    <span>2 Set:</span>{' '}
                    <strong className="Spectro">Spectro</strong> DMG +
                    <strong>10%</strong>.
                  </p>
                  <p>
                    <span>5 Set:</span> Inflicting enemies with Spectro Frazzle
                    increases Crit. Rate by <strong>20%</strong> for{' '}
                    <strong>15s</strong>. Attacking enemies with 10 stacks of
                    Spectro Frazzle grants <strong>15%</strong>{' '}
                    <strong className="Spectro">Spectro DMG</strong> Bonus for{' '}
                    <strong>15s</strong>.
                  </p>
                </>
              )}
              {set === 'Midnight Veil' && (
                <>
                  <p>
                    <span>2 Set:</span> <strong className="Havoc">Havoc</strong>{' '}
                    DMG +<strong>10%</strong>.
                  </p>
                  <p>
                    <span>5 Set:</span> When Outro Skill is triggered, deal
                    additional 480% <strong className="Havoc">Havoc DMG</strong>{' '}
                    to surrounding enemies, considered Outro Skill DMG, and
                    grant the incoming Resonator 15%{' '}
                    <strong className="Havoc">Havoc DMG</strong> Bonus for 15s.
                  </p>
                </>
              )}
              {set === 'Empyrean Anthem' && (
                <>
                  <p>
                    <span>2 Set:</span> Energy Regen +<strong>10%</strong>.
                  </p>
                  <p>
                    <span>5 Set:</span> Increase the Resonator's Coordinated
                    Attack DMG by <strong>80%</strong>. Upon a critical hit of
                    Coordinated Attack, increase the active Resonator's ATK by{' '}
                    <strong>20%</strong> for <strong>4s</strong>.
                  </p>
                </>
              )}
              {set === 'Tidebreaking Courage' && (
                <>
                  <p>
                    <span>2 Set:</span> Energy Regen +<strong>10%</strong>.
                  </p>
                  <p>
                    <span>5 Set:</span> Increase the Resonator's ATK by{' '}
                    <strong>15%</strong>. Reaching 250% Energy Regen increases
                    all Attribute DMG by <strong>30%</strong> for the Resonator.
                  </p>
                </>
              )}
              {set === 'Gusts of Welkin' && (
                <>
                  <p>
                    <span>2 Set:</span> <strong className="Aero">Aero</strong>{' '}
                    DMG +<strong>10%</strong>.
                  </p>
                  <p>
                    <span>5 Set:</span> Inflicting{' '}
                    <strong className="Aero">Aero Erosion</strong> upon enemies
                    increases <strong className="Aero">Aero DMG</strong> for all
                    Resonators in the team by <strong>15%</strong>, and for the
                    Resonator triggering this effect by an additional{' '}
                    <strong>15%</strong>, lasting for <strong>20s</strong>.
                  </p>
                </>
              )}
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
};
